(function () {
  var roots = document.querySelectorAll('[data-oddit-currency]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    var form = root.querySelector('form');
    var native = root.querySelector('[data-oddit-currency-native]');
    var button = root.querySelector('[data-oddit-currency-button]');
    var list = root.querySelector('[data-oddit-currency-list]');
    if (!form || !native || !button || !list) return;

    var options = list.querySelectorAll('[data-oddit-currency-option]');
    if (!options.length) return;

    // Progressive enhancement: the native select is the no-JS path. Only once we
    // know the custom control can run do we swap them over.
    native.classList.add('oddit-footer-main__visually-hidden');
    native.setAttribute('tabindex', '-1');
    button.hidden = false;

    var isOpen = false;

    function activeIndex() {
      for (var i = 0; i < options.length; i++) {
        if (options[i].getAttribute('aria-selected') === 'true') return i;
      }
      return 0;
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      list.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      var current = options[activeIndex()];
      if (current) current.focus();
    }

    function close(refocus) {
      if (!isOpen) return;
      isOpen = false;
      list.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      if (refocus) button.focus();
    }

    function commit(value) {
      native.value = value;
      // Some themes bind to change; dispatch before submitting so they stay in sync.
      native.dispatchEvent(new Event('change', { bubbles: true }));
      form.submit();
    }

    button.addEventListener('click', function () {
      if (isOpen) close(false); else open();
    });

    Array.prototype.forEach.call(options, function (option, index) {
      option.addEventListener('click', function () {
        commit(option.getAttribute('value'));
      });

      option.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var next = index + (e.key === 'ArrowDown' ? 1 : -1);
          if (next < 0) next = options.length - 1;
          if (next >= options.length) next = 0;
          options[next].focus();
        } else if (e.key === 'Home') {
          e.preventDefault();
          options[0].focus();
        } else if (e.key === 'End') {
          e.preventDefault();
          options[options.length - 1].focus();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          close(true);
        }
      });
    });

    button.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open();
      }
    });

    document.addEventListener('click', function (e) {
      if (isOpen && !root.contains(e.target)) close(false);
    });

    document.addEventListener('keydown', function (e) {
      if (isOpen && e.key === 'Escape') close(true);
    });
  });
})();
